import { AutoPlayPopUpController } from "@quest/murka-games-behavior-leopard/dist/Game/AutoPlayPopUp/AutoPlayPopUpController";
import { ButtonBase, dispatcher } from "@quest/base-core";
import { eventDispatchers } from "../Constants/EventDispatchers";

export class AutoPlayPopUpControllerGame extends AutoPlayPopUpController {
    /**
     * overrided to remove player msg on autoplay spin click
     */
    protected autoPlaySpinBtnClick(button?: ButtonBase): void {
        super.autoPlaySpinBtnClick(button);
        dispatcher.fireEvent(eventDispatchers.HIDE_BET_CHANGE_MSG);
    }
}